import { useSavedNodesEnabled } from './useSavedNodesEnabled';

/** Groups no longer have a gate of their own. Kept as a separate name so group call sites read clearly. */
export const useSubflowGroupsEnabled = (): boolean => useSavedNodesEnabled();
